var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("crear-permiso-cargo-vacacion"),
      _vm._v(" "),
      _c("EditarPermisoCargoVacacion"),
      _vm._v(" "),
      _c("SolicitarPermiso"),
      _vm._v(" "),
      _c("VerPermiso"),
      _vm._v(" "),
      _c("VerReporte"),
      _vm._v(" "),
      _c("AnularPermiso"),
      _vm._v(" "),
      _c("VerDocumento"),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
            _c(
              "h3",
              { staticClass: "primary--text" },
              [
                _c("v-icon", { attrs: { color: "primary" } }, [
                  _vm._v("description")
                ]),
                _vm._v(" Solicitud con cargo a\n        vacación\n      ")
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", md6: "" } },
            [
              _c("v-autocomplete", {
                staticClass: "text-field-reducido",
                attrs: {
                  items: _vm.lista_gestiones,
                  "item-text": "periodo",
                  "item-value": "periodo",
                  label: "Seleccione la gestión",
                  required: "",
                  outline: "",
                  success: "",
                  clearable: ""
                },
                on: {
                  change: function($event) {
                    return _vm.actualizarTabla()
                  }
                },
                model: {
                  value: _vm.periodo_seleccionado,
                  callback: function($$v) {
                    _vm.periodo_seleccionado = $$v
                  },
                  expression: "periodo_seleccionado"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.esUsuario
        ? _c(
            "h4",
            { staticStyle: { color: "#000" } },
            [
              _c("b", [_vm._v("NOMBRE COMPLETO:")]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" " + _vm._s(_vm.nombres) + "\n  ")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            { staticClass: "pb-0" },
            [
              _vm.sw_programacion
                ? _c(
                    "v-card",
                    {
                      staticClass:
                        "px-3 white--text text-xs-center text-md-left",
                      attrs: { color: "indigo" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs12: "", md4: "" } }, [
                            _c("span", { staticClass: "caption" }, [
                              _vm._v("DÍAS RESERVA")
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            !!_vm.datos_estado_vacacion
                              ? _c("span", { staticClass: "display-1" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.datos_estado_vacacion.dias_reserva
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs12: "", md4: "" } }, [
                            _c("span", { staticClass: "caption" }, [
                              _vm._v("DÍAS RESERVA SOLICITADOS")
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "display-1" }, [
                              _vm._v(_vm._s(_vm.total_dias_creados_reserva))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs12: "", md4: "" } }, [
                            _c("span", { staticClass: "caption" }, [
                              _vm._v("NOTA A CONSIDERAR")
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            _c("span", { staticClass: "titulo" }, [
                              _vm._v(
                                "Los días de reserva se encontrarán vigentes desde el\n              " +
                                  _vm._s(
                                    _vm
                                      .$moment(
                                        _vm.datos_programacion.fecha_corte
                                      )
                                      .format("DD/MM/YYYY")
                                  ) +
                                  "\n              hasta el 31/12/" +
                                  _vm._s(_vm.datos_programacion.gestion - 1) +
                                  ", posterior a\n              esta fecha los días no utilizados se adicionarán al total de\n              días no programados de vacación (según corresponde)\n            "
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "v-card",
                    {
                      staticClass: "px-3 white--text",
                      attrs: { color: "blue" }
                    },
                    [
                      _c("span", { staticClass: "caption" }, [
                        _vm._v("TOTAL DÍAS NO PROGRAMADOS")
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "display-1" }, [
                        _vm._v(_vm._s(_vm.total_vacacion_disponible))
                      ])
                    ]
                  )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0" },
            [
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  (_vm.sw_programacion &&
                    !!_vm.datos_estado_vacacion &&
                    _vm.datos_estado_vacacion.dias_reserva -
                      _vm.total_dias_creados_reserva >
                      0) ||
                  !_vm.sw_programacion
                    ? _c(
                        "v-btn",
                        {
                          attrs: { slot: "activator", color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.crearPermisoCargoVacacion()
                            }
                          },
                          slot: "activator"
                        },
                        [
                          _c("v-icon", [_vm._v("event_note")]),
                          _vm._v(" Nueva Solicitud\n        ")
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [_vm._v("Nueva solicitud con cargo a vacación")])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-1 tabla-comprimida-light",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.l_papeletas,
                  widthModal: 840,
                  "rows-per-page-items": [10, 25, { text: "Todos", value: -1 }]
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.numero))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.fecha_desde))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.fecha_retorno))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.nro_dias))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.estado_permiso))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.jefe &&
                                  (items.item.permiso.id_estado == 6 ||
                                    items.item.permiso.id_estado == 7)
                                  ? items.item.jefe
                                  : " "
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.fecha_emision))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.rechazo
                                  ? items.item.rechazo
                                  : items.item.justificacion
                                  ? items.item.justificacion
                                  : ""
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "nowrap text-xs-center" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "info",
                                  icon: "",
                                  title: "Ver permiso"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.verPermiso(items.item)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("remove_red_eye")])],
                              1
                            ),
                            _vm._v(" "),
                            items.item.permiso.id_estado == 22
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "warning",
                                      icon: "",
                                      title: "Modificar"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.editarPermisoCargoVacacion(
                                          items.item
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("edit")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            items.item.permiso.id_estado == 22
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "red",
                                      icon: "",
                                      dark: "",
                                      title: "Anular"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.anularPermiso(
                                          items.item.id_permiso
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("delete")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            items.item.permiso.id_estado == 75 ||
                            items.item.permiso.id_estado == 7 ||
                            items.item.permiso.id_estado == 6 ||
                            items.item.permiso.id_estado == 21 ||
                            items.item.permiso.id_estado == 77
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "#F58736",
                                      icon: "",
                                      title: "Ver reporte"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.verReporte(items.item)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("picture_as_pdf")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            items.item.permiso.id_estado == 22
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "success",
                                      icon: "",
                                      title: "Enviar"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.solicitarPermiso(items.item)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("send")])],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1498e1a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1498e1a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/papeleta_vacacion/Index.vue
// module id = null
// module chunks = 